import React, { useState } from 'react'
import cn from 'classnames'

import VNConcessionsNavBar from '../VNConcessionsNavBar'
import Lock from '@material-ui/icons/Lock'
import styles from './Component.module.scss'
import ConnectingIndicator from '../ConnectingIndicator'
import NavMenu from '../NavMenu'

import VNPinPad from '../../VNLogin/components/VNPinPad'
import { ToastManager } from '../../utils/toastManager'

/**
 * UserLoginComponent - User/Manager Login Pin Entry Screen
 *
 * @param {Object} props - The properties object.
 * @returns {JSX.Element} The rendered component.
 */
const UserLoginComponent = ({
  standName,
  pinLoginStatus,
  handleSubmit,
  approvalCodes,
  hamburgerUnlocked,
  fetchAttendantsStatus,
  isMounted,
  header = 'Enter Your Passcode',
  buttonText = 'Sign In',
  forManagerApproval = false,
}) => {
  const [pin, setPin] = useState('')
  const [openHamburgerMenu, setOpenHamburgerMenu] = useState(false)
  const checkOpenHamburger = () => {
    if (approvalCodes?.includes(pin)) {
      setOpenHamburgerMenu(true)
    }
  }

  const isLoading =
    !forManagerApproval &&
    (['loading', 'succeeded'].includes(pinLoginStatus) || fetchAttendantsStatus === 'loading' || !isMounted)

  const onHandleSubmit = () => {
    if (!approvalCodes?.includes(pin)) {
      ToastManager.error('That code did not work')
      return
    }
    handleSubmit(pin)
  }

  if (isLoading) {
    return <ConnectingIndicator />
  }

  const lockIcon = <Lock className={styles.lock} onClick={checkOpenHamburger} />

  return (
    <div className={cn(styles.container, { [styles.loading]: isLoading })}>
      <VNConcessionsNavBar
        useHamburgerIcon={hamburgerUnlocked}
        useSmallTitleFont={true}
        textDisplay={standName}
        showBorder={false}
        leftAccessory={lockIcon}
      />
      <VNPinPad pin={pin} onSetPin={setPin} onSubmit={onHandleSubmit} header={header} buttonText={buttonText} />
      {openHamburgerMenu && <NavMenu onToggle={() => setOpenHamburgerMenu(false)} />}
    </div>
  )
}

export default UserLoginComponent
